import { inject, Injectable } from '@angular/core';

import { PromoVoucher } from '@ts/promo/shared/util-core';
import { ShippingTrackableService } from '@ts/shipping/shared/util-core';
import {
  ShippingI18nService,
  ShippingMethodI18n,
} from '@ts/shipping/shared/util-i18n';

import { Order } from './order.model';
import { isOrderShippingTrackingLive } from './order-status.model';

export interface OrderDetailViewBase {
  shippingMethodI18n$: Promise<ShippingMethodI18n>;
  isShippingTrackable: boolean;
  // Every tracking fetch calls Biteship, so it is fetched only while live.
  isShippingTrackingLive: boolean;
  promoVouchers: readonly PromoVoucher[];
}

export type OrderDetailView = Readonly<OrderDetailViewBase>;

/** What both order detail pages show the same way (#11398). */
@Injectable({
  providedIn: 'root',
})
export class OrderDetailViewService {
  private shippingI18nService = inject(ShippingI18nService);
  private shippingTrackableService = inject(ShippingTrackableService);

  getOrderDetailView(order: Order): OrderDetailView {
    const shippingMethod =
      order.shipping_info.shipping_method_with_details.shipping_method;
    const isShippingTrackable =
      this.shippingTrackableService.isTrackable(shippingMethod);
    return {
      shippingMethodI18n$:
        this.shippingI18nService.methodTranslate$(shippingMethod),
      isShippingTrackable,
      isShippingTrackingLive:
        isShippingTrackable && isOrderShippingTrackingLive(order.status),
      promoVouchers: order.promo_voucher_usages.map(
        (usage) => usage.promo_voucher,
      ),
    };
  }
}
